export default function groupItem() {
  return {
    _id: false,
    type: 'droplet.groupItem',
    siteType: null,
    mediaQueries: [],
    pageCSS: '',
    groupId: null,
    bounceDroplet: false,
    isShared: false,
    templateRegion: false,
    hideFilters: false,
    customCategories: [],
    customList: false,
    paginate: 24,
    placeholder: 'Search...',
    sortKey: false,
    sort: 'newest',
    match: 'all',
    filterText: 'Filters',
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/group-item/droplet.schema.js